import $ from 'jquery';

$('.nav-toggle').on('click', function () {
    var toggleActiveClass = 'nav-toggle--active';
    var navActiveClass = 'navigation--visible';
    if ($(this).hasClass(toggleActiveClass)) {
        $(this).removeClass(toggleActiveClass);
        $('.navigation').removeClass(navActiveClass);
    } else {
        $(this).addClass(toggleActiveClass);
        $('.navigation').addClass(navActiveClass);
    }
});
